import React from 'react'
import styled from 'styled-components'
import NorthIcon from '@mui/icons-material/North'
import Text from 'core-system/Text/Text'
import palette from 'core-system/Themes/palette'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
`

const LabelRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export type ChangeVariant = 'positive' | 'negative' | 'neutral'

const ChangeContainer = styled.div<{ variant: ChangeVariant }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.325rem 0.75rem;
  border-radius: 1rem;
  background-color: ${({ variant }) => {
    if (variant === 'positive') {
      return palette.success.green200
    }
    if (variant === 'negative') {
      return palette.error.red200
    }
    if (variant === 'neutral') {
      return palette.grey.grey200
    }
  }};
  color: ${({ variant }) => {
    if (variant === 'positive') {
      return palette.success.green800
    }
    if (variant === 'negative') {
      return palette.error.red800
    }
    return palette.grey.grey800
  }};
  font-size: 0.7rem;
  font-weight: 500;
  white-space: nowrap;
`

interface TitleChangeProps {
  title: string
  subtitle?: string
  change?: string
  variant?: ChangeVariant
  titleVariant?: string
  titleFontWeight?: number
}

const TitleChange = ({
  title,
  subtitle,
  change,
  variant = 'neutral',
  titleVariant = 'h4',
  titleFontWeight = 500,
  ...props
}: TitleChangeProps) => {
  const arrayRotation = () => {
    if (variant === 'positive') {
      return 'rotate(0deg)'
    }
    if (variant === 'negative') {
      return 'rotate(180deg)'
    }
    return 'rotate(90deg)'
  }

  return (
    <Container {...props}>
      <Text variant={titleVariant} fontWeight={titleFontWeight}>
        {title}
      </Text>
      <LabelRow>
        {subtitle ? (
          <Text variant='body1' color={palette.text.secondary}>
            {subtitle}
          </Text>
        ) : null}
        {change ? (
          <ChangeContainer variant={variant}>
            <NorthIcon
              style={{
                fontSize: '0.9rem',
                transform: arrayRotation(),
              }}
            />
            {change}
          </ChangeContainer>
        ) : null}
      </LabelRow>
    </Container>
  )
}

export default TitleChange
